// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6533":"b3249b30","9552":"fab72c70"}[chunkId] + ".chunk.css";
};